export default {"src":"/_next/static/media/enhance.5c040d6a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};